import { formatDate } from '@/utils';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Configure dayjs plugins
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Format any value to show 'N/A' for null/undefined/empty strings
 * Used across all audit display components
 */
export const formatValue = (value: any): string => {
	if (value === null || value === undefined || value === '') {
		return 'N/A';
	}
	return String(value);
};

/**
 * Format date value for display using standard date formatter
 * Returns 'N/A' for invalid or missing dates
 */
export const formatDateValue = (date: Date | string | null | undefined): string => {
	if (!date) return 'N/A';
	try {
		return formatDate(date);
	} catch (error) {
		return 'N/A';
	}
};

/**
 * Format time value from date/datetime in New York timezone
 * Returns only the time portion in hh:mm A format
 * Returns 'N/A' for invalid or missing dates
 */
export const formatTimeValue = (date: Date | string | null | undefined): string => {
	if (!date) return 'N/A';
	try {
		const parsed = dayjs(date).tz('America/New_York');
		if (parsed.isValid()) {
			return parsed.format('hh:mm A');
		}
		return 'N/A';
	} catch (error) {
		return 'N/A';
	}
};

/**
 * Module filter options for audit table status dropdown
 * These correspond to the modules defined in audit.config.ts
 */
export const moduleFilterOptions = [
	{ label: 'All', value: '' },
	{ label: 'Authentication', value: 'Authentication' },
	{ label: 'Benefits Verification', value: 'Benefits Verification' },
	{ label: 'Orders Status', value: 'Orders Status' },
	{ label: 'Consignment Orders', value: 'Consignment Orders' },
	{ label: 'Return Orders', value: 'Return Orders' },
	{ label: 'Invoices', value: 'Invoices' },
	{ label: 'Patients', value: 'Patients' },
	{ label: 'Users', value: 'Users' },
	{ label: 'Support Tickets', value: 'Support Tickets' },
];
